export class AppError extends Error {
  status?: number
  statusText?: string
  errorKey?: string
  errorData?: unknown

  constructor(error: {
    status?: number
    statusText?: string
    errorKey?: string
    errorData?: unknown
  }) {
    super(
      typeof error.errorData === 'string'
        ? error.errorData
        : JSON.stringify(error.errorData || 'no errorData provided', null, 2)
    )
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AppError.prototype)

    this.name = 'AppError'
    this.status = error.status
    this.statusText = error.statusText
    this.errorKey = error.errorKey
    this.errorData = error.errorData

    // Exclude this constructor from the stack trace
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, AppError)
    }
  }
}
